export default [
    ".DS_Store",
    ".json",
    ".pdf",
    ".doc",
    ".docx",
    ".odt",
    ".rtf",
    ".txt",
    ".wps",
    ".xls",
    ".xlsx",
    ".csv",
    ".dat",
    ".pps",
    ".ppt",
    ".pptx",
    ".vcf",
    ".xml",
    ".mcs",
    ".7z",
    ".gz",
    ".rar",
    ".zip",
    ".zipx",
    ".m3u",
    ".m4a",
    ".mid",
    ".mp3",
    ".ra",
    ".wav",
    ".avi",
    ".flv",
    ".mov",
    ".mp4",
    ".mpg",
    ".rm",
    ".swf",
    ".wmv",
    ".bmp",
    ".gif",
    ".jpg",
    ".png",
    ".tif",
    ".tiff",
    ".bat",
    ".exe",
    ".jar",
    ".html",
    ".xhtml",
    ".dll",
    ".lnk",
    ".sys",
    ".drv",
    ".ini",
    ".log",
    ".stl",
    ".vrml",
    ".wrl",
    ".obj",
    ".3ds",
    ".vtk",
    ".svg",
    ".iso",
    ".msi",
    ".part"
]
